var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import { Icon } from "../../UI";

import { Translate, t } from "../../I18N";
import Icons from "./Icons";

const titles = {
  defaultTitle:
  'This property has the same configuration as others with the same label and will be used together.',
  contentConflict:
  'Properties with the same label but different thesauri as content are not allowed.',
  relationConflict:
  'Relationship properties with the same label but different relationship types are not allowed.',
  typeConflict: 'Properties with the same label but incompatible types are not allowed.',
  inheritConflict:
  'Properties with the same label but incompatible inherited types are not allowed.'
};

const selectAndDateTranslationKeys = {
  select: 'Single select',
  multiselect: 'Multiple select',
  date: 'Single date',
  daterange: 'Single date range',
  multidate: 'Multiple date',
  multidaterange: 'Multiple date range'
};

















const inheritTypeToShow = (prop) =>
prop.inheritType ? prop.inheritType[0].toUpperCase() + prop.inheritType.slice(1) : '';

const invalidType = (prop) =>
prop.typeConflict || prop.relationConflict || prop.inheritConflict;

const typeToShow = (prop) =>
selectAndDateTranslationKeys[prop.type] || `property ${prop.type}`;

const title = (prop) => {
  if (prop.inheritConflict) {
    return titles.inheritConflict;
  }
  if (prop.relationConflict) {
    return titles.relationConflict;
  }
  if (prop.typeConflict) {
    return titles.typeConflict;
  }
  return '';
};

const contentTitle = (prop) =>
prop.contentConflict ? titles.contentConflict : '';

class SimilarProperty extends Component {
  render() {
    const { templateProperty } = this.props;
    const typeIcon = templateProperty.type;
    const invalidThesauri = templateProperty.contentConflict && templateProperty.thesaurusName;
    const inheritLabel = t('System', 'Inherit', null, false);
    return /*#__PURE__*/(
      _jsx("tr", { className: "property-atributes is-active" }, void 0, /*#__PURE__*/
      _jsx("td", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "file" }), " ", templateProperty.template
      ), /*#__PURE__*/
      _jsx("td", {
        className: invalidType(templateProperty) ? 'conflict' : '',
        title: title(templateProperty) }, void 0,

      invalidType(templateProperty) && /*#__PURE__*/_jsx(Icon, { icon: "exclamation-triangle" }), "\xA0", /*#__PURE__*/

      _jsx(Icon, { icon: Icons[typeIcon] || 'fa fa-font' }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, typeToShow(templateProperty)),
      templateProperty.relationTypeName && ` (${templateProperty.relationTypeName})`,
      inheritTypeToShow(templateProperty) &&
      ` (${inheritLabel}: ${inheritTypeToShow(templateProperty)})`
      ), /*#__PURE__*/
      _jsx("td", {
        className: templateProperty.contentConflict ? 'conflict' : '',
        title: contentTitle(templateProperty) }, void 0,

      invalidThesauri && /*#__PURE__*/_jsx(Icon, { icon: "exclamation-triangle" }),
      templateProperty.thesaurusName && /*#__PURE__*/_jsx(Icon, { icon: "book" }),
      templateProperty.thesaurusName
      )
      ));

  }
}


export { SimilarProperty };